import React from 'react';
import ChecklistOptionHeader from 'components/common/headers/ChecklistOptionHeader';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';

const EmployerFormsHeader = (): JSX.Element => {
  return (
    <ChecklistOptionHeader
      tutorialLink={CARD_DATA.FORMS.tutorialLink}
      title={CARD_DATA.FORMS.title}
      subtitle={CARD_DATA.FORMS.text}
    />
  );
};

export default EmployerFormsHeader;
